(function()
{
	// Library depencencies
	var DebugOptions = include('springroll.DebugOptions', false),
		TitleState = include('PrimalSpringrollTemplate.TitleState'),
		GameState = include('PrimalSpringrollTemplate.GameState'),
		Application = include('springroll.Application'),
		Transition = include('lib.Transition'),
		Container = include('createjs.Container'),
		Bitmap = include('createjs.Bitmap'),
		Display = include('springroll.easeljs.EaselJSDisplay');

	var PrimalSpringrollTemplate = function()
	{
		Application.call(this, {
			fps: 60,
			name: 'Check Out Cookie',
			// state: 'title',
			state: 'title',
			canvasId: 'stage',
			configPath: 'assets/config/config.json',
			manifestsPath: 'assets/config/manifests.json',
			captionsPath: 'assets/config/captions.json',
			preload: [
				// assets for transition
				{
					"src":"assets/images/apple_large.png", 
					"id":"apple_large",
					"complete": onImageLoaded
				},
				{
					"src":"assets/images/bread_large.png", 
					"id":"bread_large",
					"complete": onImageLoaded
				},
				{
					"src":"assets/images/cheese_large.png", 
					"id":"cheese_large",
					"complete": onImageLoaded
				},
				{
					"src":"assets/images/apple_large2.png", 
					"id":"apple_large2",
					"complete": onImageLoaded
				},
				{
					"src":"assets/images/cheese_large2.png", 
					"id":"cheese_large2",
					"complete": onImageLoaded
				},
				{
					"id": "PlayButton",
					"src": "assets/images/PlayButton.png",
					"complete": onImageLoaded
				},
				{
					"id": "Title",
					"src": "assets/images/CheckOutCookie_Title.png",
					"complete": onImageLoaded
				}
			],
			transitionSounds: {
				"in": "",
				"out": ""
			},
			display: Display,
			displayOptions:	{
				clearView: true,
				mouseOverRate: 15
			}
		});

		this.onResize = this.onResize.bind(this);
		
		//set up listeners for initialization
		this.once("configLoaded", onConfigLoaded.bind(this));
		this.once("init", onInit.bind(this));

		this.onWindowUnload = this.onWindowUnload.bind(this);
		window.addEventListener("unload", this.onWindowUnload);

		// set up handler to resume audio context in chrome
		this.resumeAudioContext = this.resumeAudioContext.bind(this);
		window.addEventListener("click", this.resumeAudioContext);
	};

	var p = extend(PrimalSpringrollTemplate, Application);

	p.onWindowUnload = function()
	{
		window.removeEventListener("unload", this.onWindowUnload);
		
		this.destroy();//destroy the game
	};

	var onImageLoaded = function(img, asset) {
		window.images[asset.id] = img;
	};

	var onConfigLoaded = function(config, assets)
	{
		
		//force a resize now to ensure that the game doesn't think it is 1024x660
		this.triggerResize();

		// add cursor assets for desktop
		if(!this.hasTouch) {
			assets.push(this.config.assets.cursor[0]); // default cursor
			assets.push(this.config.assets.cursor[1]); // rollover cursor
		}

		app.config.globalState.timeOfGameStart = Date.now();
	};

	var onInit = function()
	{
		this.cursor = null;
		var display = this.display;
		var canvas = display.canvas;
		var stage = display.stage;

		// Add transition to the stage
		var transition = this.transition = this.options.transition = new lib.Transition();
		transition.framerate = 24;
		//set a strict size that the transition represents
		transition.width = 1320;
		transition.height = 780;
		//remove the nominal bounds, as we don't want to use it
		transition.nominalBounds = null;
		stage.addChild(transition);
		// Make sure the transition is on top of everything added before it
		transition.parent.setChildIndex(transition, transition.parent.children.length - 1); 
		//Create the calling from the configuration
		//This will only scale items on the root of the stage
		this.scaling.addItem(transition,
			{
				x:(1024-1320)/2,
				y:(660-780)/2,
				titleSafe:true,
				align:"top-left"
			});
		this.scaling.enabled = true;
		
		this.on("resize", this.onResize, -1);

		var assets = this.config.assets;
		var scaling = this.config.scaling;
		var fla = this.manifests;

		// Set the states to use
		this.states = {
			title: new TitleState({
				next: 'game',
				preload: assets.title,
				scaling: scaling.title
			}),
			game: new GameState({
				previous: 'title',
				preload: assets.game, // Include once there are game assets to load in the manifest
				scaling: scaling.game
			})
		};

		// add and bind cursor
		if(!this.hasTouch)
		{
			stage.addEventListener("mouseleave", this.stageOut.bind(this));
			stage.addEventListener("mouseenter", this.stageIn.bind(this));
			stage.addEventListener("stagemousemove", this.onMouseMove.bind(this));
			stage.addEventListener("changecursor", this.onCursorChange.bind(this));
			//hide default cursor to show sesame star cursor
			this.display.canvas.style.cursor = "none";
			//Create the cursor
			this.cursor = new Container();

			this.cursorDefault = new Bitmap(app.assetManager.cache.read("CursorDefault"));
			this.cursor.addChild(this.cursorDefault);
			this.cursorPointer = new lib.Cursor();
			this.cursor.addChild(this.cursorPointer);
			this.cursorPointer.visible = false;
			this.cursorDefault.regX = 18;
			this.cursorDefault.regY = 18;
			this.cursorPointer.regX = 18;
			this.cursorPointer.regY = 18;
			stage.addChild(this.cursor);
			this.currentDragged = this.currentDraggedOffset = null;
		}

		this.display.visible = true;

		// GA_obj.trackEvent("load", "Complete");
	};

	p.onResize = function(w, h)
	{
		//tells the container element what size to be for proper placement
		//due to absolute/relative positioning stuff
		var container = document.getElementById("container");
		if(container.scrollIntoViewIfNeeded)
			container.scrollIntoViewIfNeeded(true);
	};

	p.resumeAudioContext = function() {
		// handler for fixing suspended audio context in Chrome
		// Specifically for SoundJS
		try {
			if (createjs.WebAudioPlugin.context.state === "suspended") {
				createjs.WebAudioPlugin.context.resume();
				// Should only need to fire once
				window.removeEventListener("click", this.resumeAudioContext);
			}
		} catch (e) {
			// there was a problem with the SoundJS context...
			console.error("There was an error while trying to resume the SoundJS Web Audio context...");
			console.error(e);
		}
	};

	// Log out the qeury options
	/*if (DEBUG && DebugOptions)
	{
		DebugOptions
			.string('state', 'title, game')
			.boolean('mute', 'mute all sounds')
			.log();
	}*/

	p.stageIn = function()
	{
		if(this.cursor) {
			this.cursor.visible = true;
		}
	};

	p.stageOut = function()
	{
		// if(this.cursor) {
		// 	this.cursor.visible = false;
		// }
	};

	p.onCursorChange = function(ev)
	{
		this.cursorPointer.visible = ev.cursor == "pointer";
		this.cursorDefault.visible = ev.cursor != "pointer";
	};

	p.onMouseMove = function(ev)
	{
		this._lastStageX = ev.stageX;
		this._lastStageY = ev.stageY;

		if(this.currentDragged) {
			return;
		}

		this.cursor.x = ev.stageX;
		this.cursor.y = ev.stageY;
	};

	p.onQuitTap = function()
	{
		// GA_obj.trackEvent("button exit", GA_obj.gameID);
		window.close();
	};

	p.destroy = function()
	{
		// var timeInSeconds = Math.round((Date.now() - app.config.globalState.timeOfGameStart) / 1000);
		// GA_obj.trackEvent("QuitInfo", "GameDuration", timeInSeconds);
		
		this.onWindowUnload = null;
		
		Application.prototype.destroy.call(this);
	};

	// Give window access to the app
	window.app = new PrimalSpringrollTemplate();

}());
